//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import '../../assets/style/weui.css';
export default {

  components: {

  },
  data() {
    return {

      unitNo:'',
      amount:'',
      userShow:false,
      userCode:'',
      deviceList:[],
      dataSource:this.$cookies.get('dataSource'),
      tel:this.$cookies.get('contactNo'),
      commercialName:this.$cookies.get('commercialName'),
    };
  },
  created() {


  },

  mounted() {



  },
  methods: {
    call(tel){
      window.location.href = 'tel://'+tel
    },
    getInfo(){
      console.log('12323')
      this.$router.push('/msb/payOrder')
     /* this.$router.push({
        name: 'wUserInfo',
        query: {
          unitNo: this.unitNo,

        }
      })*/
    },
    chooseDevice(index){
      let deviceInfo=JSON.stringify(this.deviceList[index])
      this.$router.push({
        name: 'msbPayOrder',
        query: {
          deviceInfo:deviceInfo,
        }
      })
    },
    getDeviceInfo: async function(){
      this.deviceList=[]
      const _this=this;
      let params = {
        commercialNumber:this.$cookies.get('commercialNumber'),
        token:this.$cookies.get('msbToken'),
        userCode:this.userCode
      };
      console.log(params);
      const response = await this.$api.postjson("/msb/queryDevice", params);
      console.log('水费查询',response)
      if(response.data.code=='0000'){
        if(response.data.data.length==1){
          let deviceInfo=JSON.stringify(response.data.data[0])
          _this.$router.push({
            name: 'msbPayOrder',
            query: {
              deviceInfo:deviceInfo,
            }
          })
        }
        else if(response.data.data.length>1){
          _this.deviceList=response.data.data
          _this.userShow=true
        }
        else{
          _this.$vux.toast.show({
            text: '暂无数据',
            type: "warn",
            time:'3000'
          })
        }
       /* _this.address=response.data.data.row[0].address
        _this.qf=response.data.data.row[0].qf
        _this.unit_name=response.data.data.row[0].unit_name
        _this.ye=response.data.data.row[0].ye
        _this.yjqf=response.data.data.row[0].yjqf*/
      }
      else{
        _this.$vux.toast.show({
          text: response.data.msg,
          type: "warn",
          time:'3000'
        })
      }
    },

  }
};



// WEBPACK FOOTER //
// ./src/views/msb/home.vue